import dynamic from "next/dynamic";
const TopLogosComponent = dynamic(()=>import("./top-logos-component"));
import TopLogosConfig from "./top-logos-config";
import TopLogosAdvancedConfig from "./top-logos-advanced-config";
export default {
    TopLogosComponent,
    TopLogosConfig,
    TopLogosAdvancedConfig
};
